<template>
    <div id="app">
        <Header :access="access"></Header>
        <div class="vcore_container">
            <router-view :name="access"/>
        </div>
        <Footer v-if="admin"></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header";
import { mapGetters } from "vuex";
import Footer from "./components/Footer";

    export default {
        name: 'app',
        components: {
            Footer,
            Header,
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            handleResize(){
                this.$store.commit("totalWidthUpdate", window.innerWidth);
            }
        },
        data() {
            return { viewHeader: true };
        },
        computed: {
            ...mapGetters([
                "totalWidth",
                "admin"
            ]),
            access: function() {
                if(this.admin === true){
                    return "admin";
                } else if (this.admin === false){
                    return "user";
                } else {
                    return "default";
                }
            }
        },
        watch: {
            $route: {
                handler: function(to) {
                    //console.log(to.meta);
                    this.viewHeader = to.meta.header;
                },
                immediate: true
            }
        },
        mounted() {
            this.$store.commit("totalWidthUpdate", window.innerWidth);
            this.$nextTick(function() {
                window.addEventListener("resize", this.handleResize);
            });
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .vcore_row {
        margin: 0;
    }

    .header {
        background-color: white;
        border-bottom: 3px solid #999999;
        width: 100%;
        height: 72px;
    }

    .right {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 33px;
        color: $color_black;
        float: right;
        margin: 35px 100px 0 0;
        cursor: pointer;
    }

    .red-button {
        background-color: #cc0000;
        color: white;
    }

    .blue-button {
        background-color:#2b78e4;
        color: white;
    }
</style>
